<template>
  <div class="house">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>个人资源库</el-breadcrumb-item>
          <el-breadcrumb-item>资源人物管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size:18px;margin-left:5px;">
            资源人物管理
            <span style="font-size:13px;font-weight:400;">（{{totalFace || 0}}个）</span>
          </h4>
        </div>
        

        <div class="right">
          <div v-if="plFlag && isPass !== '1' && false"
               @click="plFlag = false"
               class="disflex piliang">
            <div class="img"></div>
            <p>批量处理</p>
          </div>

          <div v-if="!plFlag"
               class="disflex">
            <el-button v-if="powersObj.createAtlas"
                       @click="closeAllChoose"
                       style="width:120px;height:40px;font-size:15px;color:#666666;border-radius:5px;">取 消</el-button>
            <el-button v-if="powersObj.createAtlas"
                       @click="allElide"
                       style="width:120px;height:40px;font-size:15px;background-color: #A3A3A3;color:#fff;border-radius:5px;">批量忽略</el-button>
            <el-button v-if="powersObj.createAtlas"
                       @click="allMergePeople"
                       style="width:120px;height:40px;font-size:15px;background-color: #185ED3;color:#fff;border-radius:5px;">批量合并</el-button>
            <el-button v-if="powersObj.createAtlas"
                       @click="allSelect"
                       style="width:120px;height:40px;font-size:15px;color:#666666;border-radius:5px;">{{choice}}</el-button>
          </div>
          <!-- @click="allMarkPeople" -->
        </div>
      </div>
      <div class="tab-index">
        <div class="tabs">
          <el-radio-group v-model="isImportant" @input="importantChange">
            <el-radio-button :label="0">标注人物</el-radio-button>
            <el-radio-button :label="1">重要人物</el-radio-button>
            <el-radio-button :label="2">非标注人物</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="searchbjlist" v-if="importantChangeFlag">
        <div class="searchbj">
          <div class="belongpic">
            <h5>地区:</h5>
            <p v-for="(e,i) in regionListS"
               :key="i"
               @click="regionClick(i,e.id)"
               :class="regionFlag === i ? 'active':''">{{e.name}}</p>
          </div>
          <div class="belongpic">
            <h5>分类:</h5>
            <p v-for="(e,i) in peopleClassListS"
               :key="i"
               @click="peopleClassClick(i,e.id)"
               :class="peopleClassFlag === i ? 'active':''">{{e.name}}</p>
          </div>

          <div class="disFlex">
            <!-- 是否忽略 -->
            <div class="coninput">
              <h5 style="width:70px;">是否忽略:</h5>
              <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'" v-model="isPass"
                              size="mini">
                <el-radio-button label="1">是</el-radio-button>
                <el-radio-button label="0">否</el-radio-button>
              </el-radio-group>
              <!-- <i class="dateicon el-icon-date"></i> -->
            </div>
            <!-- 创建人 -->
            <div class="coninput">
              <h5 style="width:50px;">创建人:</h5>
              <el-select v-model="faceCreate"
                         :filter-method="selectFaceCreate"
                         filterable
                         placeholder="不限">
                <el-option v-for="item in faceCreateList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
              </el-select>
              <!-- <i class="dateicon el-icon-date"></i> -->
            </div>
            <!-- 人物姓名 -->
            <div class="coninput">
              <h5 style="width:70px;">人物姓名:</h5>
              <el-input class="elinput"
                        v-model="peopleName"
                        style="width:300px"
                        placeholder="请输入人物姓名"></el-input>
              <!-- <i class="dateicon el-icon-date"></i> -->
            </div>

            <el-button @click="searchClick"
                       class="btn">搜索</el-button>
          </div>
        </div>

      </div>
      <seePeopleFace ref="seePeopleFace"></seePeopleFace>

      <div v-if="!plFlag"
           style="width:calc(100% - 40px);height:10px;margin:0 auto;margin-bottom:-15px;background:#185ed3;padding:0 20px;box-sizing: border-box;"></div>
      <div class="piclist"
           v-loading='facePeopleLoading'
           :style="{'grid-template-columns': `repeat(${faceRow},1fr)`}">

        <div class="face"
             v-for="(e,i) in faceList"
             :key="'face'+i"
             @click="!plFlag && chooseFace(e)">
          <el-image class="faceimg"
                    :src="e.src"
                    @contextmenu.prevent="rightShow($event)"
                    ondragstart="return false;"
                    @click="seePeopleFaceList(e)"></el-image>
          <!-- <div class="faceimg" :style="{background:'url('+ e.src +') center center no-repeat'}"></div> -->

          <div class="faceinfo">
            <el-tooltip class="item"
                        effect="dark"
                        :content="e.peopleName"
                        placement="top">
              <p v-if="e.peopleName.length > 9">{{e.peopleName.substring(0,9) + '…'}}</p>
            </el-tooltip>
            <p v-if="e.peopleName.length <= 9">{{e.peopleName}}</p>
            <!-- <p>{{e.peopleName}}</p> -->
            <div style="margin:8px 0;cursor:pointer;"
                 @click="seePeopleFaceList(e)">关联资源 {{e.faceCount}}个</div>
            <div v-if="plFlag"
                 class="handle disflex">
              <div class="disflex bjrw"
                   @click="markFace(e)"
                   v-if="e.isPass !== 1"
                   style="margin-right:20px;">
                <div class="img"></div>
                <div>修改人物信息</div>
              </div>
              <div v-if="plFlag && e.isPass == 0"
                   class="hl"
                   @click="oneElide(e.id)">忽略</div>
              <div v-if="plFlag && e.isPass == 1"
                   class="hl"
                   @click="oneUnElide(e.id)">取消忽略</div>
            </div>
          </div>

          <div v-if="!plFlag"
               class="choose">
            <img :src=" batchFace.indexOf(e) === -1 ?require('@/assets/personpic/choose.png'):require('@/assets/personpic/choosehover.png')"
                 alt />
          </div>
        </div>

        <!-- <template v-if="faceList.length%faceRow > 0">
          <div class="list" :style="{width:widthWithUPFace}" v-for="(item,index) in (faceRow-(faceList.length)%faceRow)" :key="'facelist'+index"></div>
        </template> -->

        <template v-if="faceList.length === 0">
          <div class="nopic">
            <img src="@/assets/piclist/nonr.png"
                 alt="">
          </div>
        </template>
        <img v-if="showLoading"
             class="myloading"
             width="200px"
             src="@/assets/blue-preloader.gif"
             alt />
      </div>

    </div>

    <el-dialog :visible.sync="dialogVisible"
               width="30%"
               :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>修改人物</div>
      </div>
      <el-form v-loading='faceLoading'
               :model="faceRuleForm"
               :rules="faceRules"
               ref="faceRuleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="人物分类："
                      prop="peopleClass">
          <el-select v-model="faceRuleForm.peopleClass"
                     style="width:100%;"
                     placeholder="请选择人物分类">
            <el-option v-for="(e,i) in peopleClassList"
                       :key="'peopleClass'+i"
                       :label="e"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区："
                      prop="region">
          <el-select v-model="faceRuleForm.region"
                     style="width:100%;"
                     placeholder="请选择地区">
            <el-option v-for="(e,i) in regionList"
                       :key="'region'+i"
                       :label="e"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名："
                      prop="name">
          <el-input v-model="faceRuleForm.name"
                    @input="myInput"></el-input>
        </el-form-item>
        <el-form-item label=""
                      prop="isImportannt">
          <el-checkbox v-model="faceRuleForm.isImportant">是否重要人物</el-checkbox>
        </el-form-item>
      </el-form>

      <div v-if="false"
           style="width:90%;margin:20px auto;">
        <p style="margin-top:30px;margin-bottom:10px;">注：如人物已存在，您可以通过输入姓名检索并合并</p>
        <el-table :data="faceData"
                  v-if="faceInputFlag"
                  style="width: 100%"
                  border>
          <el-table-column prop="name"
                           label="人物姓名"
                           :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <el-image style="width:22px;height:22px;border-radius: 50%;margin-left:10px;"
                        :src="scope.row.peopleLogo"
                        :preview-src-list="[scope.row.peopleLogo]"></el-image>
              <span>{{scope.row.peopleName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createname"
                           label="创建人">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <p @click="mergeFace"
                 style="color:#185ED3;cursor: pointer;">合并</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                  :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="beSure('faceRuleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { searchAtlas } from '@/api/search'
import { listUser } from "@/api/user";
import { formatConversion } from '@/plugins/getdate'
import { listLib } from "@/api/lib";
import { picPrefix } from "@/constants/piccommon";
import { addAtlas, updateAtlas } from "@/api/atlas";
import { listPeopleFaceByPeopleId,listNonAnnotated } from "@/api/peopleFace";
import { listPeople, setPass, markPeople, getPeopleConstant, mergePeople } from "@/api/people";
import { powersObj, allowLib } from "@/constants/powers";

import { changedescdialog } from '@/components/index'
import { seePeopleFace } from '@/components/index'

import picview from '@/components/picView/picView'
export default {
  inject: ['reload'],
  components: { changedescdialog, picview, seePeopleFace },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {

      //筛选内容
      peopleClassListS: [
        {
          id: -1,
          name: "全部"
        }
      ],
      //状态筛选
      regionListS: [
        {
          id: -1,
          name: "全部"
        }
      ],
      isImportant: 0,//0 标注人物 1 重要人物 2 非标注人物
      importantChangeFlag:true,
      peopleClassFlag: 0,
      regionFlag: 0,
      isPass: '0',
      faceCreate: '',
      faceCreateList: [],
      peopleClassId: '',
      regionId: '',
      peopleName: '',

      //标记人物
      dialogVisible: false,

      //根据分辨率判断长度
      documentHeight: 0,
      minRows: 8,
      maxRows: 12,


      //权限
      powersObj,
      allowLib,


      //批量操作
      plFlag: true,

      //人脸失败的分辨率
      faceRow: 1,
      widthWithUPFace: '',

      //分辨率
      row: 1,
      widthWithUP: '',
      displayResolution: 0,

      //图集间距
      atlasMargin: '',

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,


      //选中的图片
      choosePic: [],


      //当日所有的图片
      testList: [],
      //当月所有的图片
      testListMonth: [],

      //存储所有未整理图片
      allPicList: [],

      atlasId: '',
      libId: '',
      isSave: false,

      //是按天还是按月排序   
      picSortFlag: true,
      picinfClass: "picinf",

      //时间排序 
      sortFlag: true,

      //未整理图片的个数
      nnclutteredPic: "",

      currentPage: 0,

      //显示我的资源集还是未整理图片   0为图集
      isPic: 0,


      faceMarginTop: '',

      //人脸识别
      //分页
      totalFace: 0,
      pageSizeFace: 30,
      pageFace: 0,
      faceList: [],

      //批量标识
      batchFlag: 0,

      //批量loading
      facePeopleLoading: false,

      faceLoading: false,
      peopleClassList: [],
      regionList: [],
      faceIds: [],
      faceRuleForm: {
        peopleClass: '',
        region: '',
        name: '',
        id: '',
        peopleLogo: '',
        isImportant:false,
      },
      faceRules: {
        peopleClass: [{ required: true, message: "请选择人物分类", trigger: "blur" }],
        region: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },

      faceData: [
        {
          name: '领导',
          createname: '李四'
        }, {
          name: '领导',
          createname: '李四'
        }, {
          name: '领导',
          createname: '李四'
        }
      ],

      faceInputFlag: false,

      batchFace: [],

      isRefresh: false,

      choice: '全 选',
      showLoading: false,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      clickFaceDialog: false,//点击人脸查看或修改
      seeOrUpdateFace: 0,//查看或者修改人脸
      nowPeopleInfo: '',//当前人脸信息
    };
  },
  methods: {
    
    seePeopleFaceList (info) {
      if(info.faceCount == 0){
        this.$message('关联资源为空！')
        return
      }
      // console.log(info);
      this.$router.push({
        path:'/myLib/seepersonface',
        query:{
          id:info.id,
          title:info.peopleName,
          count:info.faceCount
        }
      })
      // info.peopleId = info.id
      // this.$refs.seePeopleFace.getInfo(info)
    },
    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },

    //取消
    closeAllChoose(){
      this.plFlag = true
      this.allSelect()
    },

    //全选
    allSelect () {

      // if(this.batchFace.length > 0){
      //   this.choice = '取消全选'
      //   for (let i = 0; i < this.faceList.length; i++) {
      //     this.batchFace.push(this.faceList[i])
      //   }
      // }else{
      if (this.batchFace.length == this.faceList.length || this.batchFace.length > 0) {
        this.batchFace = []
        this.choice = '全 选'
      } else {
        this.choice = '取消全选'
        this.batchFace = []
        for (let i = 0; i < this.faceList.length; i++) {
          this.batchFace.push(this.faceList[i])
        }
      }
      // }

      console.log(this.batchFace.length, this.faceList.length);
      console.log(this.faceList);


    },
    importantChange(val) {
      this.importantChangeFlag =true
      console.log(val);
      console.log(this.isImportant);
      if (this.isImportant == 2) {
        this.importantChangeFlag = false
        console.log(111);
        this.peopleClassFlag = 0;
        this.peopleClassId = 0;
        this.regionFlag = 0;
        this.regionId = 0;
        this.faceCreate = -1;
        this.peopleName = '';
        this.isPass = 0;
      }
      this.searchClick()
    },

    //筛选内容
    peopleClassClick(i, id) {
      console.log(i,id);
      this.peopleClassFlag = i;
      this.peopleClassId = id;
      this.searchClick()
    },

    //状态筛选
    regionClick(i, id) {
      console.log(i,id);
      this.regionFlag = i;
      this.regionId = id;
      this.searchClick()
    },
    

    searchClick () {
      this.pageFace = 0;
      let params = {
        createUid: this.faceCreate == -1 ? null : this.faceCreate || null,
        name: this.peopleName,
        region: this.regionId || null,
        peopleClass: this.peopleClassId || null,
        isPass: this.isPass,
        page: this.pageFace,
        pageSize: this.pageSizeFace,
        fuzzySearch: true,
        isImportant:this.isImportant
      };
      if (this.isImportant==2) {
        this.getNonAnnotated()
      } else {
        this.listPeopleAsync(params)
      }
    },

    myAtlasClick () {
      this.isPic = 0
      this.uploadMode = 0
      this.choosePic = []
    },

    changeUploadMode () {
      if (this.uploadMode === 0) {

        this.uploadMode = 1
      } else {
        this.uploadMode = 0
      }
    },
    rowClick (row) {
      // this.myLibId = row.libId
      this.myAtlasId = row.atlasId
    },
    myLibChange () {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = []
        this.mySearchAtlasAsync({ pageSize: 50, page: 0, createUid: this.createUid })
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = []
        this.mySearchAtlasAsync({ keyword: this.myselect, pageSize: 50, page: 0, createUid: this.createUid })
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    async mySearchAtlasAsync (val) {
      let { status, data, message } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name: '[' + (data[i].libInfo ? data[i].libInfo.name : '暂无') + '] ' + data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id

          });

        }
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
      }
    },


    //新增资源集
    addAtlasClick () {
      this.atlasName = '新建资源集'
      this.dialogVisiblePutIn = true;
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0"
      }
      this.$refs["addRuleForm"].resetFields();
      this.listLibAsync()
    },
    handleClosePutIn () {
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0"
      }
      this.$refs["addRuleForm"].resetFields();
      this.dialogVisiblePutIn = false;
    },
    dev () {
      this.$message("正在开发中……")
    },

    subPutIn () {
      this.$refs["addRuleForm"].validate(valid => {
        if (valid) {
          this.dialogLoading = true;
          if (this.atlasName == '新建资源集') {
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              sourceType: "0",
              createUid: this.createUid,
              indexpicId: "0"
            };
            this.addAtlasAsync(data);
            this.dialogVisiblePutIn = false;
            setTimeout(() => {
              this.$router.push({
                name: "pictureUpload", //跳转的路径
                params: {
                  atlas: this.atlasInfo
                }
              });
            }, 500);
          } else {
            this.dialogVisiblePutIn = false;
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              createUid: this.createUid,
              id: this.ruleForm.id,
              indexpicId: this.ruleForm.indexpicId,
              sourceType: this.ruleForm.sourceType,
            };
            this.updateAtlasAsync(data)
          }

        } else {
          return false;
        }
      });
    },

    //选择批量人脸
    chooseFace (i) {
      if (this.batchFace.indexOf(i) === -1) {
        this.batchFace.push(i)
      } else {
        this.batchFace.splice(this.batchFace.indexOf(i), 1)
      }
      if (this.batchFace.length > 0) {
        this.choice = '取消所选'
      }
    },

    handleClose () {
      this.dialogVisible = false
      this.$refs['faceRuleForm'].resetFields();
    },
    beSure (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.faceLoading = true
          if (this.plFlag) {

            let val = {
              id: this.faceRuleForm.id,
              peopleClass: this.faceRuleForm.peopleClass,
              peopleName: this.faceRuleForm.name,
              region: this.faceRuleForm.region,
              peopleLogo: this.faceRuleForm.peopleLogo || '',
              isImportant:this.faceRuleForm.isImportant==true?1:0
            }
            // console.log('标记人物', val);
            this.markPeopleAsync(val)

          } else {

            for (let i = 0; i < this.batchFace.length; i++) {
              let val = {
                id: this.batchFace[i].id,
                peopleClass: this.faceRuleForm.peopleClass,
                peopleName: this.faceRuleForm.name,
                region: this.faceRuleForm.region,
                peopleLogo: this.batchFace[i].peopleLogo,
                isImportant:this.faceRuleForm.isImportant==true?1:0
              }
              this.markPeopleBatchAsync(val)
            }

            setTimeout(() => {
              this.plFlag = true
              this.facePeopleLoading = false
              let val = {
                page: this.pageFace,
                pageSize: this.pageSizeFace,
                isImportant:this.isImportant

              }
              this.listPeopleAsync(val)
            }, 2000);
            this.$refs['faceRuleForm'].resetFields();

          }



        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //单个取消忽略操作
    oneUnElide (i) {
      this.$confirm('确认取消忽略吗？',{
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          let val = {
            id: i,
            isPass: 0
          }
          this.setPassAsync(val)
        })
        .catch(e => {
          console.log('取消')
        });
    },
    //单个忽略操作
    oneElide (i) {
      this.$confirm('确认忽略吗？',{
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          let val = {
            id: i,
            isPass: 1
          }
          this.setPassAsync(val)
        })
        .catch(e => {
          console.log('取消')
        });
    },
    //批量合并操作
    allMergePeople () {
      if (this.batchFace.length == 0) {
        this.$message.warning('请选择！')
        return false
      }
      this.$confirm('确认合并选中人物吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.facePeopleLoading = true
          let mergeData = []
          for (let i = 0; i < this.batchFace.length; i++) {
            mergeData.push(this.batchFace[i].id)

          }
          let val = {
            peopleIds: mergeData.join(',')
          }
          this.mergePeopleAsync(val)
          setTimeout(() => {
            this.plFlag = true
            this.batchFace = []
            this.facePeopleLoading = false
            this.batchFlag = 0
            let val = {
              createUid: this.faceCreate == -1 ? null : this.faceCreate || null,
              name: this.peopleName || null,
              region: this.regionId || null,
              peopleClass: this.peopleClassId || null,
              isPass: this.isPass || null,
              page: this.pageFace,
              pageSize: this.pageSizeFace,
              fuzzySearch: true,
              isImportant:this.isImportant

            }
            this.listPeopleAsync(val)
          }, 1500);
        })
    },
    //批量忽略操作
    allElide () {
      if (this.batchFace.length == 0) {
        this.$message.warning('请选择！')
        return false
      }
      this.$confirm('确认忽略选中人物吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.facePeopleLoading = true
          for (let i = 0; i < this.batchFace.length; i++) {
            let val = {
              id: this.batchFace[i].id,
              isPass: 1
            }
            this.setPassBatchAsync(val)
          }
          setTimeout(() => {
            this.plFlag = true
            this.batchFace = []
            this.facePeopleLoading = false
            this.batchFlag = 0
            let val = {
              createUid: this.faceCreate == -1 ? null : this.faceCreate || null,
              name: this.peopleName || null,
              region: this.regionId || null,
              peopleClass: this.peopleClassId || null,
              isPass: this.isPass || null,
              page: this.pageFace,
              pageSize: this.pageSizeFace,
              fuzzySearch: true,
              isImportant:this.isImportant
            }
            this.listPeopleAsync(val)
          }, 1500);
        })
        .catch(e => {
          console.log('取消')
        });
    },

    //批量标记人物
    allMarkPeople () {
      if (this.batchFace.length == 0) {
        this.$message.warning('请选择！')
        return false
      }
      this.dialogVisible = true
    },
    //合并操作
    mergeFace () {
      this.$confirm('确认合并吗？',{
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {

        })
        .catch(e => {
          console.log('取消')
        });
    },
    myInput (item) {
      if (item.length >= 2) {
        this.faceInputFlag = true
      }
    },



    //刷新表格
    refresh () {
      this.faceCreate = "";
      this.peopleName = "";
      this.regionId = "";
      this.isPass = ''
      this.peopleClassFlag = 0
      this.regionFlag = 0
      this.isRefresh = true
      this.pageFace = 0
      if (this.isImportant!=2) {
        let val = {
          page: this.pageFace,
          pageSize: this.pageSizeFace,
          isImportant:this.isImportant
        }
        this.listPeopleAsync(val)
        this.listUserAsync()
      } else {
        this.getNonAnnotated()
      }
      //获取用户列表

      this.displayResolution = document.documentElement.clientWidth;

      setInterval(() => {
        this.checkRow()
      }, 666);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },




    //滚动加载图库和图片
    scrollPic () {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight

      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      // this.pic.id = scrollTop
      if (isBottom) {
        // if (this.isPic === 0) {
        // } else if (this.isPic === 1) {
        // } else if (this.isPic == 2) {
        if (this.faceList.length !== this.totalFace && this.passFlag) {
          this.showLoading = true
          this.passFlag = false
          setTimeout(() => {
            this.pageFace++
            // this.showLoading = false
            if (this.isImportant!==2) {
              this.listPeopleAsync({
              pageSize: this.pageSizeFace, page: this.pageFace,
              isImportant:this.isImportant
            })
            } else {
            this.getNonAnnotated()
              
            }

            // console.log(this.picList)
          }, 400);
        }
        // }


      }
      if (scrollTop >= 216) {
        this.picinfClass = "picinf picinfpos";
      } else {
        this.picinfClass = "picinf";
      }
    },

    //检索创建人
    selectFaceCreate (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query, userType: 0 }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20, userType: 0 }
        this.listUserAsync(dataExa)
      }
    },

    //获取内部用户列表
    async listUserAsync (val) {
      let { status, data, message, pagination, errors } = await listUser(val);
      if (status) {
        // console.log(dataRole)
        this.faceCreateList = [
          {
            value:-1,
            label:'不限'
          }
        ]
        for (let i = 0; i < data.length; i++) {
          this.faceCreateList.push({
            value: data[i].id,
            label: data[i].name
          })
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext })
      }
    },


    //人脸相关操作
    markFace(e) {
      console.log(e);
      this.dialogVisible = true
      this.faceRuleForm.id = e.id
      this.faceRuleForm.peopleLogo =this.isImportant==2?'': e.peopleLogo
      
      this.faceRuleForm.peopleClass =this.isImportant==2?'':  e.peopleClass
      this.faceRuleForm.region =this.isImportant==2?'':  e.region
      this.faceRuleForm.name =this.isImportant==2?'':  e.peopleName
      this.faceRuleForm.isImportant =this.isImportant==2?false: e.isImportant==1?true:false
    },

    //通过人物编号获取对应的人脸列表  
    async listPeopleFaceByPeopleIdAsync (val) {
      let { status, data, message } = await listPeopleFaceByPeopleId(val);
      if (status) {
      }
    },


    //忽略人物
    async setPassAsync (val) {
      let { status, data, message, errors } = await setPass(val);
      if (status) {
        let val = {
          createUid: this.faceCreate == -1 ? null : this.faceCreate || null,
          name: this.peopleName,
          region: this.regionId,
          peopleClass: this.peopleClassId,
          isPass: this.isPass,
          page: this.pageFace,
          pageSize: this.pageSizeFace,
          fuzzySearch: true,
          isImportant:this.isImportant
        }
        this.listPeopleAsync(val)
        this.$message.success(message)
      } else {
        this.$message.success('忽略失败！')
      }
    },

    //批量合并人物
    async mergePeopleAsync (val) {
      let { status, data, message } = await mergePeople(val);
      this.batchFlag++
      if (status) {
        // this.$message.success(message)
      } else {
        this.$message.success('合并失败！')
      }
      if (this.batchFlag == this.batchFace.length) {
        this.$message.success('合并成功！')
      }
    },

    //批量忽略人物
    async setPassBatchAsync (val) {
      let { status, data, message } = await setPass(val);
      this.batchFlag++
      if (status) {
        // this.$message.success(message)
      } else {
        this.$message.success('忽略失败！')
      }
      if (this.batchFlag == this.batchFace.length) {
        this.$message.success('忽略成功！')
      }
    },

    //标记人物
    async markPeopleAsync (val) {
      let { status, data, message } = await markPeople(val);
      this.faceLoading = false
      if (status) {
        this.searchClick()
        this.$message.success(message)
        this.dialogVisible = false
        this.$refs['faceRuleForm'].resetFields();
      } else {
        this.$message.error('标记失败！')
        return false;
      }
    },

    //批量标记人物
    async markPeopleBatchAsync (val) {
      let { status, data, message } = await markPeople(val);
      this.batchFlag++
      if (status) {
        // this.$message.success(message)
      } else {
        this.$message.success('标记失败！')
      }
      if (this.batchFlag == this.batchFace.length) {
        this.$message.success('标记成功！')
      }
      this.dialogVisible = false
      this.faceLoading = false
    },

    //获取人物列表
    async listPeopleAsync (val) {
      let { status, data, message, pagination } = await listPeople(val);
      if (status) {
        if (this.pageFace === 0) {
          this.faceList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.faceList.push(data[i])
          }
        }
        this.totalFace = pagination.total
        for (let i = 0; i < this.faceList.length; i++) {
          if (!this.faceList[i].peopleLogo || this.faceList[i].peopleLogo == this.faceList[i].peopleName) {
            this.faceList[i].src = require('@/assets/personpic/face.png')
          } else {
            this.faceList[i].src = picPrefix + this.faceList[i].peopleLogo
          }

        }
        this.checkRow()
        if (this.faceList.length <= 0) {
          this.faceRow = 1
        }
      }
      this.isRefresh = false
      this.showLoading = false
      this.passFlag = true
    },
    // 获取非标注人物
    async getNonAnnotated() {
      let params = {
        page:this.pageFace,
        pageSize:10,
      }
    let { status, data, message,pagination } = await listNonAnnotated(params)
      if (status) {
        console.log(data);
        data.forEach((ele) => {
              ele.peopleName = '未命名',
              ele.faceCount = 0,
              ele.peopleLogo = ele.thumb
        })
        if (this.pageFace === 0) {
          
          this.faceList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.faceList.push(data[i])
          }
        }
        this.totalFace = pagination.total
        for (let i = 0; i < this.faceList.length; i++) {
          if (!this.faceList[i].peopleLogo || this.faceList[i].peopleLogo == this.faceList[i].peopleName) {
            this.faceList[i].src = require('@/assets/personpic/face.png')
          } else {
            this.faceList[i].src = picPrefix + this.faceList[i].peopleLogo
          }

        }
        this.checkRow()
        if (this.faceList.length <= 0) {
          this.faceRow = 1
        }
        this.totalFace = pagination.total
      } else {
        this.$message.error(message)
      }
    this.isRefresh = false
    this.showLoading = false
    this.passFlag = true
    },

    //获取标记人物的值
    async getPeopleConstantAsync () {
      let { status, data, message } = await getPeopleConstant();
      if (status) {
        this.regionList = data.region
        this.peopleClassList = data.peopleClass
        this.regionListS = [
          {
            id: 0,
            name: "全部"
          }
        ]
        this.peopleClassListS = [
          {
            id: 0,
            name: "全部"
          }
        ]
        for (let i = 0; i < data.region.length; i++) {
          this.regionListS.push({
            id: data.region[i],
            name: data.region[i]
          })
        }

        for (let i = 0; i < data.peopleClass.length; i++) {
          this.peopleClassListS.push({
            id: data.peopleClass[i],
            name: data.peopleClass[i]
          })
        }
      }
    },



    //获取图片库列表
    async listLibAsync () {
      let { status, data, message } = await listLib();
      if (status) {

      }

    },

    //判断分辨率
    judgRes () {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    },

    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2800) {
        this.row = 8
        this.widthWithUP = "13%"
        this.faceRow = 8
        this.widthWithUPFace = '23.5%'
      } else
        if (this.displayResolution > 2700) {
          this.row = 7
          this.widthWithUP = "13%"
          this.faceRow = 7
          this.widthWithUPFace = '23.5%'
        } else
          if (this.displayResolution > 2500) {
            this.row = 6
            this.widthWithUP = "13%"
            this.faceRow = 6
            this.widthWithUPFace = '23.5%'
          } else
            if (this.displayResolution > 2400) {
              this.row = 5
              this.widthWithUP = "14%"
              this.faceRow = 5
              this.widthWithUPFace = '23.5%'
            } else
              if (this.displayResolution > 2000) {
                this.row = 4
                this.widthWithUP = "16%"
                this.faceRow = 4
                this.widthWithUPFace = '23.5%'
              } else

                if (this.displayResolution > 1700) {
                  this.row = 4
                  this.widthWithUP = "18%"
                  this.faceRow = 4
                  this.widthWithUPFace = '23.5%'
                }
      if (this.displayResolution <= 1700) {
        this.row = 3
        this.widthWithUP = "21.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1600) {
        this.row = 3
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1550) {
        this.row = 2
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1400) {
        this.row = 2
        this.widthWithUP = "25%"
        this.faceRow = 2
        this.widthWithUPFace = '25%'
      }
    }





  },
  created () {


    //获取用户列表
    this.listUserAsync()


    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight

    if (this.documentHeight <= 650) {
      this.minRows = 0
      this.maxRows = 1
    } else if (this.documentHeight <= 775) {
      this.minRows = 4
      this.maxRows = 8
    } else if (this.documentHeight <= 970) {
      this.minRows = 8
      this.maxRows = 12
    }

    setInterval(() => {
      this.judgRes()
    }, 888);



    if (this.faceList.length / this.faceRow <= 2) {
      this.faceMarginTop = '-255px'
    }
    if (this.faceList.length / this.faceRow > 2) {
      this.faceMarginTop = '-160px'
    }
    if (this.faceList.length / this.faceRow > 3) {
      this.faceMarginTop = '20px'
    }

    this.getPeopleConstantAsync()

    this.isRefresh = true
    //获取人物列表
    let val = {
      page: this.pageFace,
      pageSize: this.pageSizeFace,
      isImportant:this.isImportant

    }
    this.listPeopleAsync(val)

    this.checkRow()
  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on('changeIsaside', (message) => {
      this.bus.val = message
      this.isAside = this.bus.val
      // this.isChildren = false
    })
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./peoplemanage.scss";
@import "@/constants/elHeader.scss";
/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}

.el-radio-group ::v-deep .is-active .el-radio-button__inner {
  background: #185ed3;
  border-color: #185ed3;
}
.seeInfo {
  background: #f2f2f2 !important;
  border: 1px solid rgba(119, 119, 119, 0.1);
  color: #333333;
  margin-right: -40px;
}

//改变图片放大的关闭的位置
::v-deep .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}
::v-deep .el-icon-circle-close {
  margin-top: 100px;
  color: white;
}
</style>
